import Select from "./Select";

const timeUnitOptions = [
    { label: "Second", value: "second" },
    { label: "Minute", value: "minute" },
    { label: "Hour", value: "hour" },
    { label: "Day", value: "day" },
    { label: "Week", value: "week" },
    { label: "Month", value: "month" },
];

interface Props {
    autoFocus?: boolean;
    name?: string;
}

const SelectTimeUnit = ({ autoFocus, name = "time_unit" }: Props) => {
    return (
        <Select
            autoFocus={autoFocus}
            name={name}
            label="Time Unit"
            options={timeUnitOptions}
            data-testid="time-unit-trigger"
        />
    );
};

export default SelectTimeUnit;
